<template>
    <div class="container">
        <div style="height:50px; margin:5px 16px 0 0px;">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" @change="getData" placeholder="请选择学校">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>

            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="primary"  @click="generateData">生成学段</el-button>
            </div>
        </div>

        <el-table
            :data="data"
            v-loading="loading"
            height="230"
            element-loading-background = "rgba(255, 255,255,0.7)"
            :element-loading-text = "loadingText"
            style="width: 100%;margin-bottom: 20px;"
            border>
            <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
            <el-table-column prop="esName" label="学段名称"></el-table-column>
            <el-table-column fixed="right" label="操作"  width="210">
                <template slot-scope="scope">
                    <el-button style="color: #387EE8;" 
                        @click.native.prevent="setGrade(scope.row)"
                        type="text"
                        size="small">
                        设置学段年级
                    </el-button>
                    <el-button style="color: #387EE8;" 
                        @click.native.prevent="getGrade(scope.row)"
                        type="text"
                        size="small">
                        查看学段年级
                    </el-button>
                    <el-button style="color: red" @click.native.prevent="del(scope.row)"
                        type="text"
                        size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新建学年-->
        <add-form v-model="addFormVisible" :parentData="data" :deptId="form.deptId" @submit="getData" />
        <!-- 设置学段年级-->
        <set-grade-form v-model="setGradeFormVisible" :esId="form.esId" :deptId="form.deptId" @submit="getData" />
        <!-- 查看学段年级-->
        <grade-info v-model="gradeInfoVisible" :esId="form.esId" :deptId="form.deptId" @submit="getData" />
        
    </div>
</template>

<script>
    import http from '../../../../../common/http';
    import addForm from "./components/addForm";
    import setGradeForm from "./components/setGradeForm";
    import gradeInfo from "./components/gradeInfo";

    export default {
        name:"",
        data(){
            return{
                loading: false,
                loadingText: "",
                addFormVisible: false,
                setGradeFormVisible: false,
                gradeInfoVisible: false,
                form:{
                    id:"",
                    deptId:"",
                    esId:""
                },
                depts:[],
                data:[]
            }
        },
        components: {
            addForm, setGradeForm, gradeInfo
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts = [];
                        for(let i=0;i<res.data.list.length;i++){
                            let sdata=res.data.list[i];
                            if(sdata.name.indexOf('学区')==-1){
                                this.depts.push(res.data.list[i]);
                            }
                        }
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                let url  = this.archiveSetEducationalStageListUrl;
                let data = {
                    deptId:this.form.deptId,
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.loading=true
                this.loadingText = "数据加载中..."
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
            },
            // 生成学段
            generateData(){
                this.addFormVisible = true
            },
            // 设置学段年级
            setGrade(data){
                this.form.esId = data.id
                this.setGradeFormVisible = true
            },
            // 查看学段年级
            getGrade(data){
                this.form.esId = data.id
                this.gradeInfoVisible = true
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.archiveSetEducationalStageRemoveUrl;
                let data = {
                    id:this.form.id
                };

                this.loading=true
                this.loadingText = "数据删除中..."
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip("删除成功",1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading = false
                },(err)=>{
                    console.log(err);
                    this.loading = false
                })
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/sys/dept/setgrade/List.vue